import { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ClubHome from "./ClubHome";
import TestFlow from "./TestFlow";
import ClientPage from "./ClientPage";
import TeamArea from "./TeamArea";
import AuthCallback from "./AuthCallback";

const FONTS = "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&family=Manrope:wght@400;500;600;700&display=swap";

export default function ClubApp() {
  const location = useLocation();
  useEffect(() => {
    document.title = "Diamond Club";
    if (!document.getElementById("club-fonts")) {
      const l = document.createElement("link");
      l.id = "club-fonts"; l.rel = "stylesheet"; l.href = FONTS;
      document.head.appendChild(l);
    }
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", "#0E0E10");
    const apple = document.createElement("link");
    apple.rel = "apple-touch-icon"; apple.href = "/club/icon-180.png"; apple.id = "club-apple-icon";
    if (!document.getElementById("club-apple-icon")) document.head.appendChild(apple);
    const cap = document.createElement("meta");
    cap.name = "apple-mobile-web-app-capable"; cap.content = "yes"; cap.id = "club-apple-cap";
    if (!document.getElementById("club-apple-cap")) document.head.appendChild(cap);
  }, []);

  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <div className="club-root min-h-screen bg-[#0E0E10] text-[#F4EFE6]" style={{ fontFamily: "Manrope, ui-sans-serif, system-ui" }}>
      <style>{`.club-root .font-club-display{font-family:Fraunces,Georgia,serif}.club-root ::selection{background:#E5B13A;color:#15120A}`}</style>
      <Toaster theme="dark" position="top-center" richColors />
      <Routes>
        <Route index element={<ClubHome />} />
        <Route path="i/:slug" element={<TestFlow />} />
        <Route path="c/:token" element={<ClientPage />} />
        <Route path="team/*" element={<TeamArea />} />
        <Route path="club/*" element={<Navigate to={(location.pathname.replace(/^\/club/, "") || "/") + location.search} replace />} />
        <Route path="*" element={<ClubHome />} />
      </Routes>
    </div>
  );
}
